import { useEffect, useState } from "react";
import side_img from "../../assets/pic/login-bg2.png";
import { Link } from "react-router-dom";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";
import { LayoutForLandingPage } from "./Home";
import SignupOTP from "../../components/SignupOTP";

const Login = () => {
  const [navigateLoader, setNavigateLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [OTPModal, setOTPModal] = useState(false);
  const [verifyToken, setVerifyToken] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  // New state to control password visibility
  const [showWrongCredentials, setShowWrongCredentials] = useState(false);
  const [loader, setLoader] = useState(false);
  const togglePasswordVisibilty = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    setShowWrongCredentials(false);
    const login = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password,
            role: "customer",
          }),
        }
      );
      const data = await res.json();
      console.log({ data });
      setLoader(false);
      if (data?.code === 200) {
        localStorage.setItem("token", data.data.token);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": data.data.token,
            },
          }
        );
        const user = await response.json();
        console.log({ user });
        localStorage.setItem("ID", user.detail._id);
        localStorage.setItem("username", user.detail.fullName);
        toast.success("Logged in successfully");
        window.location.href = "/dashboard/print";
      } else if (
        data.code === 450 &&
        data.message === "Email is not Verified"
      ) {
        setOTPModal(true);
        setVerifyToken(data.token);
        // toast.info(
        //   "Your email address is not verified. Please go to the 'Forgot Password' page to verify your email."
        // );
      } else {
        setShowWrongCredentials(true);
        return;
      }
    };
    login();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setNavigateLoader(true);
      setTimeout(() => {
        window.location.href = "/dashboard/print";
      }, 2000);
    }
  }, []);

  if (navigateLoader) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spinner props={"Navigating to Dashboard"} size={"120px"} />
      </div>
    );
  } else {
    return (
      <LayoutForLandingPage>
        <section className="flex justify-center items-center h-screen mt-4">
          {/* Card Container */}
          <div className="flex w-full bg-white rounded-lg shadow-lg overflow-hidden">
            {/* Left Section (Image) */}
            <div className="w-full xl:w-1/2 h-full hidden xl:block">
              <img
                src={side_img}
                alt="login_signup_side_bg"
                className="w-full h-full object-cover"
              />
            </div>
            {OTPModal && <SignupOTP token={verifyToken} />}
            {/* Right Section (Form) */}
            <form
              className="w-full xl:w-1/2 p-8 space-y-6 flex flex-col justify-center"
              onSubmit={handleSubmit}
            >
              <h1 className="text-4xl font-bold text-slate-500">Login</h1>

              {showWrongCredentials && (
                <p className="text-md text-[#C10020]">
                  Your credentials are wrong.
                </p>
              )}

              {/* Email Input */}
              <div className="w-full">
                <label className="text-lg font-semibold mb-2">Email ID</label>
                <input
                  type="text"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className={`w-full py-3 border-b-2 focus:outline-none placeholder-gray-400 ${
                    showWrongCredentials ? "border-primary" : "border-gray-400"
                  }`}
                />
              </div>

              {/* Password Input */}
              <div className="w-full relative">
                <label className="text-lg font-semibold mb-2">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  className={`w-full py-3 border-b-2 focus:outline-none placeholder-gray-400 ${
                    showWrongCredentials ? "border-primary" : "border-gray-400"
                  }`}
                />
                <div
                  className="absolute inset-y-0 right-3 top-1/2 transform -translate-y-1/2 flex items-center cursor-pointer"
                  onClick={togglePasswordVisibilty}
                >
                  {showPassword ? (
                    <BsEye size={30} className="text-gray-500" />
                  ) : (
                    <BsEyeSlash size={30} className="text-gray-500" />
                  )}
                </div>
              </div>

              {/* Forgot Password Link */}
              <Link
                to="/forgot_password"
                className="text-blue-700 text-sm hover:underline w-full text-right"
              >
                Forgot Password?
              </Link>

              {/* Loader or Button */}
              {loader ? (
                <Spinner size="80" />
              ) : (
                <button className="bg-[#F66] text-white font-semibold text-xl rounded-lg px-10 py-2 hover:bg-primary-dark transition duration-200 ease-linear w-full">
                  Log in
                </button>
              )}

              {/* Signup Link */}
              <p className="text-sm">
                Don't have an account?{" "}
                <Link to="/signup" className="text-blue-700 hover:underline">
                  Sign up
                </Link>
              </p>
            </form>
          </div>
        </section>
      </LayoutForLandingPage>
    );
  }
};

export default Login;
